import React from "react";

export const Divider = () => (
  <div className="w-full h-0 border-black-custom border bg-black-custom" />
);
